'use client'

import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from '@/components/ui/form'
import { Switch } from '@/components/ui/switch'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { ReactNode } from 'react'

/**
 * Switch/toggle form field component
 * @template TFormValues - The form values type extending FieldValues
 */
interface SwitchFormFieldProps<TFormValues extends FieldValues> {
    form: UseFormReturn<TFormValues>
    name: Path<TFormValues>
    disabled?: boolean
    label?: string
    bordered?: boolean
    description?: ReactNode
    onChange?: (value: boolean) => void
}

export const SwitchFormField = <TFormValues extends FieldValues>({
    form,
    name,
    disabled,
    label,
    description,
    bordered,
    onChange
}: SwitchFormFieldProps<TFormValues>) => {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem
                    className={`flex flex-row items-center justify-between rounded-lg space-x-4 ${bordered ? 'border p-4' : ''}`}>
                    <div className='space-y-0.5 mt-2'>
                        {label && <FormLabel className='text-base'>{label}</FormLabel>}
                        {description && <FormDescription>{description}</FormDescription>}
                    </div>
                    <FormControl>
                        <Switch
                            checked={field.value}
                            onCheckedChange={(value) => {
                                field.onChange(value)
                                if (onChange) {
                                    onChange(value)
                                }
                            }}
                            disabled={disabled ? disabled : false}
                        />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
